export const featuresTables = {
  "en": {
    usage: {
      tableHead: {
        th1: 'Usage',
        th2: 'Personal',
        th3: 'Personal Pro',
        th4: 'Team',
        th5: 'Enterprise'
      },
      row1: {
        th: 'Projects',
        td1: '100',
        td2: 'Unlimited',
        td3: 'Unlimited',
        td4: 'Unlimited',
      },
      row2: {
        th: 'Channels',
        td1: 'Unlimited',
        td2: 'Unlimited',
        td3: 'Unlimited',
        td4: 'Unlimited',
      },
      row3: {
        th: 'Team members',
        td1: 'Just you',
        td2: 'Just you',
        td3: 'Unlimited',
        td4: 'Unlimited',
      },
      row4: {
        th: 'Monthly active users (MAU) included',
        td1: 2500,
        td2: 5000,
        td3: 10000,
        td4: 'Custom',
      },
      row5: {
        th: 'Each additional MAU per month',
        td1: 'Upgrade to Personal Pro',
        td2: '$0.025',
        td3: '$0.02',
        td4: 'Custom',
      },
    },
    storage: {
      tableHead: {
        th1: 'Storage & Analytics',
        th2: 'Personal',
        th3: 'Personal Pro',
        th4: 'Team',
        th5: 'Enterprise'
      },
      row1: {
        th: 'Storage',
        td1: '1 GB',
        td2: 'Unlimited',
        td3: 'Unlimited',
        td4: 'Unlimited',
      },
      row2: {
        th: 'Analytics',
        td1: 'Yes',
        td2: 'Yes',
        td3: 'Yes',
        td4: 'Yes',
      },
      row3: {
        th: 'Conversation history',
        td1: '3 months',
        td2: '1 year',
        td3: 'Unlimited',
        td4: 'Unlimited',
      }
    },
    features: {
      tableHead: {
        th1: 'Features',
        th2: 'Personal',
        th3: 'Personal Pro',
        th4: 'Team',
        th5: 'Enterprise'
      },
      row1: {
        th: 'Team collaboration',
        td1: '-',
        td2: '-',
        td3: 'tick',
        td4: 'tick',
      },
      row2: {
        th: 'Templates',
        td1: 'Standard',
        td2: 'Standard',
        td3: 'Premium',
        td4: 'Premium',
      },
      row3: {
        th: 'Sandbox',
        td1: 'tick',
        td2: 'tick',
        td3: 'tick',
        td4: 'tick',
      },
      row4: {
        th: 'Languages',
        td1: 'Up to 2',
        td2: 'Up to 4',
        td3: 'Maximum',
        td4: 'Maximum',
      },
      row5: {
        th: 'Publishing service',
        td1: 'tick',
        td2: 'tick',
        td3: 'tick',
        td4: 'tick',
      },
    },
    support: {
      tableHead: {
        th1: 'SUPPORT & CUSTOMER SUCCESS',
        th2: 'Personal',
        th3: 'Personal Pro',
        th4: 'Team',
        th5: 'Enterprise'
      },
      row1: {
        th: 'Access to customer support',
        td1: 'Standard',
        td2: '24/7 support',
        td3: '24/7 support',
        td4: '24/7 priority support',
      },
      row2: {
        th: 'Support channels',
        td1: 'Email',
        td2: 'Email & chat',
        td3: 'Email & chat',
        td4: 'Email, chat and phone',
      },
      row3: {
        th: 'Designated customer success manager',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row4: {
        th: 'Custom natural language processing / understanding',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row5: {
        th: 'Onboarding guidance',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row6: {
        th: 'Implemention and expert guidance',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row7: {
        th: 'Operations guidance	',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
    },
  },
  "zh": {
    usage: {
      tableHead: {
        th1: '用额',
        th2: '个人版',
        th3: '进阶版',
        th4: '团队',
        th5: '企业'
      },
      row1: {
        th: '项目',
        td1: '100',
        td2: '无限',
        td3: '无限',
        td4: '无限',
      },
      row2: {
        th: '频道',
        td1: '无限',
        td2: '无限',
        td3: '无限',
        td4: '无限',
      },
      row3: {
        th: '团队',
        td1: '一位',
        td2: '一位',
        td3: '无限',
        td4: '无限',
      },
      row4: {
        th: '每月活跃用户（用户）',
        td1: 2500,
        td2: 5000,
        td3: 10000,
        td4: '无限',
      },
      row5: {
        th: '每名额外用户 / 每月',
        td1: '升级至进阶版',
        td2: '$0.025',
        td3: '$0.02',
        td4: '另行定价',
      },
    },
    storage: {
      tableHead: {
        th1: '储存及分析',
        th2: '个人版',
        th3: '进阶版',
        th4: '团队',
        th5: '企业'
      },
      row1: {
        th: '数据储存',
        td1: '1 GB',
        td2: '无限',
        td3: '无限',
        td4: '无限',
      },
      row2: {
        th: '数据分析',
        td1: 'Yes',
        td2: 'Yes',
        td3: 'Yes',
        td4: 'Yes',
      },
      row3: {
        th: '对话历史',
        td1: '3个月 ',
        td2: ' 1年',
        td3: '无时限',
        td4: '无时限',
      }
    },
    features: {
      tableHead: {
        th1: '功能',
        th2: '个人版',
        th3: '进阶版',
        th4: '团队',
        th5: '企业'
      },
      row1: {
        th: '团队协作',
        td1: '-',
        td2: '-',
        td3: 'tick',
        td4: 'tick',
      },
      row2: {
        th: '范本',
        td1: '通用范本',
        td2: '通用范本',
        td3: '进阶范本',
        td4: '客制化范本',
      },
      row3: {
        th: '测试',
        td1: 'tick',
        td2: 'tick',
        td3: 'tick',
        td4: 'tick',
      },
      row4: {
        th: '语言',
        td1: '1-2',
        td2: '1-4',
        td3: '所有已支援语言',
        td4: '指定语言',
      },
      row5: {
        th: '发布服务',
        td1: 'tick',
        td2: 'tick',
        td3: 'tick',
        td4: 'tick',
      },
    },
    support: {
      tableHead: {
        th1: '支援',
        th2: '个人版',
        th3: '进阶版',
        th4: '团队',
        th5: '企业'
      },
      row1: {
        th: '客户服务',
        td1: '标准',
        td2: '24/7',
        td3: '24/7',
        td4: '24/7 优先支援',
      },
      row2: {
        th: '支援方式',
        td1: '电邮',
        td2: '电邮及聊天室',
        td3: '电邮及聊天室',
        td4: '电邮、聊天室及真人对话',
      },
      row3: {
        th: '指定客服',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row4: {
        th: '客制NLP',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row5: {
        th: '员工培训',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row6: {
        th: '工程师指导及户口创建',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row7: {
        th: '执行指引',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
    },
  },
  "zh-hk": {
    usage: {
      tableHead: {
        th1: '用途',
        th2: '個人版',
        th3: '進階版',
        th4: '團隊',
        th5: '企業'
      },
      row1: {
        th: '項目',
        td1: '100',
        td2: '無限',
        td3: '無限',
        td4: '無限',
      },
      row2: {
        th: '頻道',
        td1: '無限',
        td2: '無限',
        td3: '無限',
        td4: '無限',
      },
      row3: {
        th: '團隊',
        td1: '一位',
        td2: '一位',
        td3: '無限',
        td4: '無限',
      },
      row4: {
        th: '每月活躍用戶（用戶)',
        td1: 2500,
        td2: 5000,
        td3: 10000,
        td4: '另行定價',
      },
      row5: {
        th: '每名額外用戶/每月',
        td1: '升級至進階版',
        td2: '$0.025',
        td3: '$0.02',
        td4: '另行定價',
      },
    },
    storage: {
      tableHead: {
        th1: '儲存及分析',
        th2: '個人版',
        th3: '進階版',
        th4: '團隊',
        th5: '企業'
      },
      row1: {
        th: '數據儲存',
        td1: '1 GB',
        td2: '無限',
        td3: '無限',
        td4: '無限',
      },
      row2: {
        th: '數據分析',
        td1: 'Yes',
        td2: 'Yes',
        td3: 'Yes',
        td4: 'Yes',
      },
      row3: {
        th: '對話歷史',
        td1: '3 個月',
        td2: '1 年',
        td3: '無時限',
        td4: '無時限',
      }
    },
    features: {
      tableHead: {
        th1: '功能',
        th2: '個人版',
        th3: '進階版',
        th4: '團隊',
        th5: '企業'
      },
      row1: {
        th: '團隊協作',
        td1: '-',
        td2: '-',
        td3: 'tick',
        td4: 'tick',
      },
      row2: {
        th: '範本',
        td1: '標準範本',
        td2: '標準範本',
        td3: '特定行業範本',
        td4: '特定行業範本',
      },
      row3: {
        th: '測試',
        td1: 'tick',
        td2: 'tick',
        td3: 'tick',
        td4: 'tick',
      },
      row4: {
        th: '語言',
        td1: '1-2',
        td2: '1-4',
        td3: '所有已支援語言',
        td4: '指定語言',
      },
      row5: {
        th: '發佈服務',
        td1: 'tick',
        td2: 'tick',
        td3: 'tick',
        td4: 'tick',
      },
    },
    support: {
      tableHead: {
        th1: '支援',
        th2: '個人版',
        th3: '進階版',
        th4: '團隊',
        th5: '企業'
      },
      row1: {
        th: '客戶服務',
        td1: '標準',
        td2: '24/7',
        td3: '24/7',
        td4: '24/7 優先支援',
      },
      row2: {
        th: '支援方式',
        td1: '電郵',
        td2: '電郵及聊天室',
        td3: '電郵及聊天室',
        td4: '電郵、聊天室及真人對話',
      },
      row3: {
        th: '指定客服',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row4: {
        th: '客製NLP',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row5: {
        th: '員工培訓',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row6: {
        th: '工程師指導及創立戶口',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
      row7: {
        th: '操作指南',
        td1: '-',
        td2: '-',
        td3: '-',
        td4: 'tick',
      },
    },
  },
} 

//toolTips ------------------
// --------------------------
export const toolTips = {
  "en": {
    project: "A project is one bot running on multiple channels",
    channels: "A channel is a voice assistant or messaging app that your bot runs on, such as Alexa or Facebook Messenger",
    teamMembers: "Members can work on the same projects together",
    mau: "A monthly active user is an end-user who has interacted (sent or received) with your bot in the month. MAU's included mean the number of MAU's that come complimentary with your plan",
    mauMonth: "For each additional MAU exceeding the amount included in your plan",
    templates: "Use and customize powerful recipes for bots, organized by industry or type",
    sandbox: "Preview and test your bot live on your devices immediately, requiring no setup",
    languages: "The number of languages a single bot can simultaneously support",
    publishServices: "If you choose, we can publish your bot for you on selected channels",
    nlp: "For businesses with complex natural language processing needs and require tailored machine learning and training",
  },
  "zh": {
    project: "一个项目是指一个bot在一个或多个频道上运行",
    channels: "频道是指Google助理、Alexa、Siri、WhatsApp、LINE、微信等的语音助理或聊天App",
    teamMembers: "成员可以共同编辑同一个项目",
    mau: "使用您的语音Bot的终端用户。不同频道的使用者计算为独立用户，同一使用者以不同装置登入，则计算为同一个用户。用户量每月计算",
    mauMonth: "当使用人数超出该户口的每月上限，即需升级或每名超额使用者另行收费",
    templates: "根据不同行业或类别的需要而设，可供修改及编辑",
    sandbox: "在发布之前，您可在心仪的频道上事先预览您的bot",
    languages: "同一个bot可以同时以不同语言发布",
    publishServices: "您可选择使用Delight Labs的发布服务，自动发布Bot到您的自选频道",
    nlp: "为指定客户的Bot，度身订造语言及机械学习训练，提升准确度",
  },
  "zh-hk": {
    project: "一個項目是指一個bot在一個或多個頻道上運行",
    channels: "频道是指Google助理、Alexa、Siri、WhatsApp、LINE、微信等的语音助理或聊天App",
    teamMembers: "成員可以共同編輯同一個項目",
    mau: "使用您的語音Bot的終端用戶。不同頻道的使用者計算為獨立用戶，同一使用者以不同裝置登入，則計算為同一個用戶。用戶量每月計算",
    mauMonth: "當使用人數超出該戶口的每月上限，則需升級或每名超額使用者另行收費",
    templates: "根據不同行業或類別的需要而設，可供修改及編輯",
    sandbox: "在發佈之前，您可在心儀的頻道上事先預覽您的bot",
    languages: "同一個bot可以同時以不同語言發佈",
    publishServices: "您可選擇使用Delight Labs的發佈服務，自動發佈Bot到您的自選頻道",
    nlp: "為指定客戶的Bot，度身訂造語言及機械學習訓練，提升準繩度",
  }
}



// export const featuresTables = {
//   "en": [
//     [
//       ['Usage', 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['projects', '100', 'Unlimited', 'Unlimited', 'Unlimited'],
//       ['channels', 'Unlimited', 'Unlimited', 'Unlimied', 'Unlimited'],
//       ['team memmbers', 'Just you', 'Just you', 'Unlimited', 'Unlimited'],
//       ['Monthly active users (MAU) included', 2500, 5000, 10000, 'Custom'],
//       ['Each additional MAU per month', 'Upgrade to Personal Pro', '$0.025', '$0.02', 'Custom']
//     ],
//     [
//       ["Storage & Analytics", 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['storage', '1 GB', 'Unlimited', 'Unlimited', 'Unlimited'],
//       ['Analytics', 'Yes', 'Yes', 'Yes', 'Yes'],
//       ['Conversation history', '3 months', '1 year', 'Unlimited', 'Unlimited']
//     ],
//     [
//       ["Features", 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['team collaboration', 'No', 'No', 'Yes', 'Yes'],
//       ['templates', 'Standard', 'Standard', 'Premium', 'Premium'],
//       ['sandbox', 'yes', 'yes', 'yes', 'yes'],
//       ['languages', 'Up to 2', 'Up to 4', 'Maximum', 'Maximum'],
//       ['Publishing service', 'yes', 'yes', 'yes', 'yes']
//     ],
//     [
//       ['Support & Customer', 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['Access to customer support', 'Standard', '24/7 support', '24/7 support', '24/7 priority support'],
//       ['Support channels', 'Email', 'Email & chat', 'Email & chat', 'Email, chat and phone'],
//       ['Designated customer success manager', 'No', 'No','No','Yes'],
//       ['Custom natural language processing / understanding', 'No', 'No','No','Yes'],
//       ['Onboarding guidance', 'No', 'No','No','Yes'],
//       ['Implemention and expert guidance', 'No', 'No','No','Yes'],
//       ['Operations guidance', 'No', 'No','No','Yes']
//     ]
//   ],
//   "zh": [
//     [
//       ['Usage', 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['projects', '100', 'Unlimited', 'Unlimited', 'Unlimited'],
//       ['channels', 'Unlimited', 'Unlimited', 'Unlimied', 'Unlimited'],
//       ['team memmbers', 'Just you', 'Just you', 'Unlimited', 'Unlimited'],
//       ['Monthly active users (MAU) included', 2500, 5000, 10000, 'Custom'],
//       ['Each additional MAU per month', 'Upgrade to Personal Pro', '$0.025', '$0.02', 'Custom']
//     ],
//     [
//       ["Storage & Analytics", 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['storage', '1 GB', 'Unlimited', 'Unlimited', 'Unlimited'],
//       ['Analytics', 'Yes', 'Yes', 'Yes', 'Yes'],
//       ['Conversation history', '3 months', '1 year', 'Unlimited', 'Unlimited']
//     ],
//     [
//       ["Features", 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['team collaboration', 'No', 'No', 'Yes', 'Yes'],
//       ['templates', 'Standard', 'Standard', 'Premium', 'Premium'],
//       ['sandbox', 'yes', 'yes', 'yes', 'yes'],
//       ['languages', 'Up to 2', 'Up to 4', 'Maximum', 'Maximum'],
//       ['Publishing service', 'yes', 'yes', 'yes', 'yes']
//     ],
//     [
//       ['Support & Customer', 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['Access to customer support', 'Standard', '24/7 support', '24/7 support', '24/7 priority support'],
//       ['Support channels', 'Email', 'Email & chat', 'Email & chat', 'Email, chat and phone'],
//       ['Designated customer success manager', 'No', 'No','No','Yes'],
//       ['Custom natural language processing / understanding', 'No', 'No','No','Yes'],
//       ['Onboarding guidance', 'No', 'No','No','Yes'],
//       ['Implemention and expert guidance', 'No', 'No','No','Yes'],
//       ['Operations guidance', 'No', 'No','No','Yes']
//     ]
//   ],
//   "zh-hk": [
//     [
//       ['Usage', 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['projects', '100', 'Unlimited', 'Unlimited', 'Unlimited'],
//       ['channels', 'Unlimited', 'Unlimited', 'Unlimied', 'Unlimited'],
//       ['team memmbers', 'Just you', 'Just you', 'Unlimited', 'Unlimited'],
//       ['Monthly active users (MAU) included', 2500, 5000, 10000, 'Custom'],
//       ['Each additional MAU per month', 'Upgrade to Personal Pro', '$0.025', '$0.02', 'Custom']
//     ],
//     [
//       ["Storage & Analytics", 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['storage', '1 GB', 'Unlimited', 'Unlimited', 'Unlimited'],
//       ['Analytics', 'Yes', 'Yes', 'Yes', 'Yes'],
//       ['Conversation history', '3 months', '1 year', 'Unlimited', 'Unlimited']
//     ],
//     [
//       ["Features", 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['team collaboration', 'No', 'No', 'Yes', 'Yes'],
//       ['templates', 'Standard', 'Standard', 'Premium', 'Premium'],
//       ['sandbox', 'yes', 'yes', 'yes', 'yes'],
//       ['languages', 'Up to 2', 'Up to 4', 'Maximum', 'Maximum'],
//       ['Publishing service', 'yes', 'yes', 'yes', 'yes']
//     ],
//     [
//       ['Support & Customer', 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//       ['Access to customer support', 'Standard', '24/7 support', '24/7 support', '24/7 priority support'],
//       ['Support channels', 'Email', 'Email & chat', 'Email & chat', 'Email, chat and phone'],
//       ['Designated customer success manager', 'No', 'No','No','Yes'],
//       ['Custom natural language processing / understanding', 'No', 'No','No','Yes'],
//       ['Onboarding guidance', 'No', 'No','No','Yes'],
//       ['Implemention and expert guidance', 'No', 'No','No','Yes'],
//       ['Operations guidance', 'No', 'No','No','Yes']
//     ]
//   ],
// } 